module.exports = __webpack_public_path__ + "static/media/tablet-apex-cover.686429eb.png";